var DataLocationStorageType = /* @__PURE__ */ ((DataLocationStorageType2) => {
  DataLocationStorageType2["Cosmos"] = "Cosmos";
  DataLocationStorageType2["AzureBlob"] = "AzureBlob";
  DataLocationStorageType2["ADLSGen2"] = "ADLSGen2";
  DataLocationStorageType2["MT"] = "MT";
  DataLocationStorageType2["ADLSGen2CosmosView"] = "ADLSGen2CosmosView";
  return DataLocationStorageType2;
})(DataLocationStorageType || {});
var DataLocationFileFormat = /* @__PURE__ */ ((DataLocationFileFormat2) => {
  DataLocationFileFormat2["Parquet"] = "Parquet";
  DataLocationFileFormat2["CosmosView"] = "CosmosView";
  return DataLocationFileFormat2;
})(DataLocationFileFormat || {});
var AuthenticationType = /* @__PURE__ */ ((AuthenticationType2) => {
  AuthenticationType2["ManagedIdentity"] = "ManagedIdentity";
  AuthenticationType2["Secret"] = "Secret";
  AuthenticationType2["ServicePrincipal"] = "ServicePrincipal";
  AuthenticationType2["Legacy"] = "Legacy";
  return AuthenticationType2;
})(AuthenticationType || {});
var ColumnMultilineKey = /* @__PURE__ */ ((ColumnMultilineKey2) => {
  ColumnMultilineKey2["Name"] = "Name";
  ColumnMultilineKey2["Type"] = "Type";
  ColumnMultilineKey2["Value"] = "Value";
  ColumnMultilineKey2["SampleValue"] = "SampleValue";
  ColumnMultilineKey2["DoNotInherited"] = "DoNotInherited";
  return ColumnMultilineKey2;
})(ColumnMultilineKey || {});
var parameterType = /* @__PURE__ */ ((parameterType2) => {
  parameterType2["SystemString"] = "System.String";
  parameterType2["SystemBoolean"] = "System.Boolean";
  parameterType2["SystemInt32"] = "System.Int32";
  parameterType2["SystemInt64"] = "System.Int64";
  parameterType2["SystemDouble"] = "System.Double";
  parameterType2["CosmosDateNumber"] = "CosmosDateNumber";
  return parameterType2;
})(parameterType || {});
export {
  AuthenticationType,
  ColumnMultilineKey,
  DataLocationFileFormat,
  DataLocationStorageType,
  parameterType
};
//# sourceMappingURL=DataSourceDataCommon.js.map
